const SITE_TITLE = '[en]BMI Platform[/en][ja]BMIプラットフォーム[/ja]';
const SITE_SLOGAN = 'Neuroinformatics Platform';
// Replaces the Universal Analytics property (UA-2787315-1), shut down in 2023.
const GOOGLE_ANALYTICS_TRACKING_ID = 'G-QE6ZWVQYBJ';
const XOONIPS_ITEMTYPES = ['data', 'model', 'presentation', 'tool', 'paper', 'book', 'url', 'files'];

// Vite's BASE_URL always carries a trailing slash ('/' when the app is served
// from the document root). Strip it so it can be concatenated the same way
// CRA's Config.BASE_URL was.
const BASE_URL = import.meta.env.BASE_URL.replace(/\/$/, '');

// The former XooNIps installation lived under /researchers. It is rendered by
// the same app, with its own router basename, layout and data directory.
const RESEARCHERS_URL = `${BASE_URL}/researchers`;

export type MultiLang = 'en' | 'ja';

const Config = {
    SITE_TITLE,
    SITE_SLOGAN,
    GOOGLE_ANALYTICS_TRACKING_ID,
    XOONIPS_ITEMTYPES,
    BASE_URL,
    RESEARCHERS_URL,
};

export default Config;
